// 判断是否登录并获取其页面需要的前置数据
var isLogin = function(type = 1, loading = true) {
  // type类型(0为不需要登陆1为需要登陆)
  const Type = location.href.indexOf("?jytfFDJyrtdjy") > -1 ? 0 : 1;
  return new Promise((resolve, reject) => {
    if ((!localStorage.getItem('userInfo')||localStorage.getItem('userInfo')=='{}'||JSON.stringify(this.$store.state.userInfo)=='{}' || localStorage.getItem('sysUserId')=='null') && Type == 1 && type == 1) {
      this.$router.replace({
        path:'/login/1',
        query:{redirect:localStorage.getItem('preRoute')}
      });
    }else{
      // 判断成功
      resolve();
    }
    
    // 判断失败
    // reject();
    this.$store.commit(
      "SET_NEEDTOP",
      location.href.indexOf("login") != -1 ||
      location.href.indexOf("?jytfFDJyrtdjy") > -1 ||
      this.$store.state.isOBT
        ? false
        : true
    );
  });
};

export default isLogin;



// WEBPACK FOOTER //
// ./src/utils/isLogin.js